import { cn } from "@/lib/utils";
import Image from "next/image";

export const Logo = ({
  className,
  priority,
}: {
  className?: string;
  /** When true, preloads the logo for LCP (e.g. header on marketing pages). */
  priority?: boolean;
}) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Image
        src="/logo.png"
        alt="Ripenn"
        width={30}
        height={32}
        className="h-8 w-auto"
        priority={priority}
        fetchPriority={priority ? "high" : undefined}
      />
      <span className="font-headings text-xl font-bold text-foreground">
        Ripenn
      </span>
    </div>
  );
};

export const LogoIcon = ({ className }: { className?: string }) => {
  return (
    <Image
      src="/logo.png"
      alt="Ripenn"
      width={22}
      height={24}
      className={cn("h-6 w-auto", className)}
    />
  );
};

export const LogoStroke = ({ className }: { className?: string }) => {
  return (
    <Image
      src="/logo.png"
      alt="Ripenn"
      width={26}
      height={28}
      className={cn("h-7 w-auto opacity-50", className)}
    />
  );
};
